<div *ngIf="isLoading || isSubmitting" class="nf-overlay">
  <svg class="nf-spinner" viewBox="0 0 50 50">
    <circle class="nf-spinner__track" cx="25" cy="25" r="20"></circle>
    <circle class="nf-spinner__arc" cx="25" cy="25" r="20"></circle>
  </svg>
</div>

<form *ngIf="!isLoading" class="pb-4" [formGroup]="userForm" (ngSubmit)="onSubmit()">
  <div [style.pointer-events]="isSubmitting ? 'none' : 'auto'">
    <!-- Primary Information Accordion -->
    <div class="form-section">
      <div class="collapsible-section" [class.is-expanded]="primaryInfoExpanded">
        <button type="button" class="collapsible-header"
          (click)="primaryInfoExpanded = !primaryInfoExpanded"
          [attr.aria-expanded]="primaryInfoExpanded">
          <span class="collapsible-header-title">Primary Information</span>
          <span class="collapsible-chevron" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </button>
        <div class="collapsible-content">
          <div class="collapsible-content-inner">
            <app-dynamic-form
              [data]="primaryFields"
              [formGroup]="userForm"
              [subType]="'field'"
              [viewMode]="mode === 'view'"
              (fieldChanged)="onFormFieldChanged($event)"
            ></app-dynamic-form>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs Section -->
    <div class="tabs-overlay" *ngIf="dynamicFormTabs.length > 0">
      <p-tabs [(value)]="activeTabIndex" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab *ngFor="let tab of dynamicFormTabs" [value]="tab.value">
            <p class="font-normal text-sm">{{ tab.title }}</p>
          </p-tab>
        </p-tablist>

        <p-tabpanels>
          <p-tabpanel *ngFor="let tab of dynamicFormTabs" [value]="tab.value">
            <div *ngFor="let sub_tab of tab.sub_tabs" class="mb-6">
              <h5 *ngIf="sub_tab.show_heading" class="mb-4 font-semibold">{{ sub_tab.title }}</h5>
              <app-dynamic-form
                [data]="sub_tab.content"
                [formGroup]="userForm"
                [viewMode]="mode === 'view'"
                (fieldChanged)="onFormFieldChanged($event)">
              </app-dynamic-form>
              <!-- add a line between 2 sections-->
              <hr class="my-4" *ngIf="!sub_tab.show_heading">
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </div>

  <div class="flex justify-end gap-2 mt-4" *ngIf="mode !== 'view'">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="onCancel()"
      [disabled]="isSubmitting"
    ></p-button>
    <p-button
      label="Save"
      type="submit"
      [disabled]="isSubmitting || userForm.invalid"
      [loading]="isSubmitting"
    ></p-button>
  </div>
</form>

